import { Entity } from "@rest-hooks/rest";
import AuthdEndpoint from "./AuthdEndpoint";
import { BASE_URL } from "./constants";
import { Paging } from "./video_platform";

/**
 * Chat message entity for admin view
 */
export class ChatMessage extends Entity {
  id = "";
  content = "";
  senderId = "";
  senderName = "";
  senderAvatarUrl: string | null = null;
  timestamp = "";
  isEdited = false;
  editedAt: string | null = null;

  pk(): string | undefined {
    return this.id;
  }
}

/**
 * Response from deleting a chat message
 */
export interface DeleteMessageResponse {
  id: string;
  deletedBy: string;
  deletedAt: string;
}

/**
 * Response containing chat messages
 */
export interface ChatMessagesResponse {
  data: ChatMessage[];
  paging: Paging;
}

/**
 * Get chat messages for a meeting (admin view)
 */
export const getMeetingChatEndpoint = new AuthdEndpoint({
  urlPrefix: BASE_URL,
  path: "/admin/video-platform/meetings/:meetingId/chat",
  schema: {
    data: [ChatMessage],
    paging: {} as Paging,
  },
  searchParams: {} as {
    limit?: number;
    nextToken?: string;
    search?: string;
    senderIds?: string;  // Comma-separated list of UUIDs
    senderName?: string;
  },
});

/**
 * Delete a chat message (soft delete)
 */
export const deleteChatMessageEndpoint = new AuthdEndpoint({
  urlPrefix: BASE_URL,
  path: "/admin/video-platform/meetings/:meetingId/chat/:messageId",
  method: "DELETE",
  schema: {} as DeleteMessageResponse,
});

export const ChatResource = {
  getMeetingChat: getMeetingChatEndpoint,
  deleteMessage: deleteChatMessageEndpoint,
};
